import {Base} from "@/api/Base"

export class AuthorityListAll extends Base {
    path = "authority/listAll"
}